import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { NotificationService } from '../../../../../common';
import { Observable, of } from 'rxjs';
import {
  ShipmentTransportOrderSapDeliveriesInitialState,
  ShipmentTransportOrderSapDeliveriesLoad,
} from './shipment-transport-order-sap-deliveries.actions';
import { ShipmentSapDeliveryModel } from '../../../../../common/models/shipment-sap-delivery.model';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentTransportOrderSapDeliveriesService } from './shipment-transport-order-sap-deliveries.service';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';

export type ShipmentTransportOrderSapDeliveriesStateModel = ListServerPaginationStateModel<ShipmentSapDeliveryModel>;

const initialState: ShipmentTransportOrderSapDeliveriesStateModel = {
  ...LIST_SERVER_PAGINATION_INITIAL_STATE,
};

@State<ShipmentTransportOrderSapDeliveriesStateModel>({
  name: 'shipmentTransportOrderSapDeliveries',
  defaults: initialState,
})
@Injectable()
export class ShipmentTransportOrderSapDeliveriesState {
  @Selector()
  static getState(state: ShipmentTransportOrderSapDeliveriesStateModel): ShipmentTransportOrderSapDeliveriesStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentTransportOrderSapDeliveriesStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getSapDeliveries(state: ShipmentTransportOrderSapDeliveriesStateModel): ShipmentSapDeliveryModel[] {
    return state.items;
  }

  constructor(
    private shipmentTransportOrderSapDeliveriesService: ShipmentTransportOrderSapDeliveriesService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentTransportOrderSapDeliveriesLoad)
  getShipmentTransportOrderSapDeliveries(
    ctx: StateContext<ShipmentTransportOrderSapDeliveriesStateModel>,
    { payload }: ShipmentTransportOrderSapDeliveriesLoad,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.shipmentTransportOrderSapDeliveriesService.getShipmentTransportOrderSapDeliveries(payload).pipe(
      map((state: ShipmentTransportOrderSapDeliveriesStateModel) => {
        ctx.patchState({ ...state, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentTransportOrderSapDeliveriesInitialState)
  setInitialState(ctx: StateContext<ShipmentTransportOrderSapDeliveriesStateModel>): void {
    ctx.setState(initialState);
  }
}
